var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3924 7.93705L9.65619 2.47038C9.11019 1.84042 8.1092 1.84322 7.475 2.47878L3.58022 6.38035C2.42103 7.54088 2.08923 9.26417 2.75983 10.6459C6.76607 18.9403 13.4558 25.6391 21.7451 29.6568C23.1255 30.3273 24.8475 29.9955 26.0067 28.835L29.9379 24.897C30.5749 24.2601 30.5763 23.2535 29.9407 22.7076L24.4527 17.9969C23.8787 17.5041 22.9869 17.5685 22.4115 18.1452L20.5019 20.0575C20.4042 20.16 20.2755 20.2275 20.1356 20.2498C19.9958 20.272 19.8525 20.2478 19.7277 20.1807C16.6064 18.3834 14.0172 15.7909 12.2238 12.6674C12.1566 12.5424 12.1323 12.3989 12.1545 12.2588C12.1768 12.1187 12.2444 11.9898 12.347 11.8918L14.251 9.98653C14.8278 9.40697 14.8908 8.51102 14.3924 7.93565V7.93705Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b4d10b48120137127514cd45fea077c6.svg";
export { ForwardRef as ReactComponent };